import { useMemo } from "react";
import {
  useExpanded,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";

import { CaseAdmin, CaseDocumentAdmin } from "pwapi";

import { canViewInternalDocuments } from "shared/hooks/usePermissions";

import DocumentsColumns from "./DocumentsColumns";
import { internalDocuments } from "../documentsPanel/editDocumentsFormUtils";
import OrdersTableView from "../ordersTable/OrdersTableView";

type DocumentsTableProps = {
  adminCase?: CaseAdmin;
  documents: CaseDocumentAdmin[];
  columns: any[];
};

const DocumentsTable = ({
  adminCase,
  columns,
  documents = [],
}: DocumentsTableProps) => {
  const canViewInternalDocs = canViewInternalDocuments();
  const filteredDocuments = useMemo(() => {
    return documents.filter(
      (doc) =>
        !(!canViewInternalDocs && internalDocuments.includes(doc.category))
    );
  }, [documents, canViewInternalDocs]);

  const { headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data: filteredDocuments,
      autoResetExpanded: false,
      defaultColumn: {
        sortDescFirst: true,
      },
    },
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  return (
    <OrdersTableView
      headerGroups={headerGroups}
      rows={rows}
      prepareRow={prepareRow}
      adminCase={adminCase}
    />
  );
};

export default DocumentsColumns(DocumentsTable, {
  displayCaseInfo: false,
  showPrintLabels: true,
});
